// Azbot.js
import { useState, useEffect } from "react";

// Configuración por defecto
const defaultConfig = {
  apiServer: "https://localhost:8181",
  scan_frecuency: 0.5,
  showBuy: true,
  showSell: false,
  basecoin: "USDT",
  intervals: ["1M", "1w", "1d", "4h", "1m"],
  userIntervals: ["1M", "1w", "1d", "4h", "1m"],
  exchange: "https://api.binance.com/",
  marketType: "api/v3",
  signalBuy: true,
  signalSell: false,
  coinBase: "usdt",
  symbolGroup: "top50",
};

// Hook para manejar la configuración
export const useConfig = (userConfig = null) => {
  const [config, setConfig] = useState(userConfig || defaultConfig);

  useEffect(() => {
    if (userConfig) {
      setConfig(userConfig);
    }
  }, [userConfig]);

  return config;
};

// Hook principal de Azbot
export const useAzbot = (userConfig = null) => {
  const config = useConfig(userConfig);
  const [scanning, setScanning] = useState(false);
  const [scanFrequency, setScanFrequency] = useState(config.scan_frecuency);
  const [currentSymbol, setCurrentSymbol] = useState("");
  const [userIntervals, setUserIntervals] = useState(config.userIntervals);

  // Función para iniciar/detener el escaneo
  const toggleScan = () => {
    if (!scanning) {
      startScan();
      setScanning(true);
    } else {
      stopScan();
      setScanning(false);
    }
  };

  // Función para iniciar el escaneo
  const startScan = async () => {
    console.log("Iniciando escaneo...");
    // Aquí puedes agregar la lógica para obtener símbolos y procesarlos
  };

  // Función para detener el escaneo
  const stopScan = () => {
    console.log("Deteniendo escaneo...");
    setScanning(false);
  };

  // Función para reiniciar el escaneo
  const resetScan = () => {
    stopScan();
    console.log("Reiniciando escaneo...");
  };

  // Función para actualizar la frecuencia de escaneo
  const updateSliderValue = (value) => {
    setScanFrequency(value);
  };

  // Función para alternar intervalos
  const toggleInterval = (interval) => {
    const updatedIntervals = userIntervals.includes(interval)
      ? userIntervals.filter((i) => i !== interval)
      : [...userIntervals, interval];
    setUserIntervals(updatedIntervals);
  };

  // Función para alternar grupos de intervalos
  const toggleGroup = (group) => {
    const groupIntervals = {
      "long-term": ["1M", "1w", "3d", "1d", "12h"],
      "mid-term": ["8h", "6h", "4h", "2h", "1h"],
      "short-term": ["30m", "15m", "5m", "3m", "1m"],
    }[group] || [];

    const allSelected = groupIntervals.every((interval) =>
      userIntervals.includes(interval)
    );

    const updatedIntervals = allSelected
      ? userIntervals.filter((interval) => !groupIntervals.includes(interval))
      : [...new Set([...userIntervals, ...groupIntervals])];

    setUserIntervals(updatedIntervals);
  };

  return {
    scanning,
    scanFrequency,
    currentSymbol,
    userIntervals,
    toggleScan,
    stopScan,
    resetScan,
    updateSliderValue,
    toggleInterval,
    toggleGroup,
  };
};